import React, { useEffect } from "react";
import '../styles/Login.css';
const Login = ({login}) =>{
    useEffect(() =>{
        login();
    },[]);
    return(
        <>
            <div className="login-body">
                <div className="login-container">
                    <h1>Welcome to blink</h1>
                    <h1>IOT portal</h1>
                    <button onClick={() => {login()}}>
                        Log in with your blink account
                    </button>
                </div>
            </div>
        </>
    );
}
export default Login;